<template>
    <div class="news_announce container-fluid news_no">

        <div class="row news_pointer" @click="news_click">
            <div class="col-sm-11 my-auto">
                <div class="p-1">
                    <div class="news_date">{{ day }}</div>
                    <div class="news_title">{{ title }}</div>
                </div>
            </div>
            <div class='col-sm-1 arrow news_view' v-bind:class="{'arrow_on':act_on,'arrow_off':act_off}"></div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class='news_msg' v-bind:class="{'news_msg_on':act_on,'news_msg_off':act_off}">
                    <hr />
                    <p v-html="text"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NewsItem',

        props: {
            no: String,
            category: String,
            title: String,
            day: String,
            time: String,
            text: String
        },

        methods: {
            news_click() {
                //メッセージ表示切替
                this.act_on = !this.act_on;
                this.act_off = !this.act_off;
            }
        },
        created() {
            this.url = location.hash
            this.display_no = this.url.replace('#', '')
            if(this.display_no == this.no){
                this.news_click();
            }
      
            this.news_no = 'news'+this.no
        },
        data: function () {
            return {
                act_on: false,
                act_off: true,
                display_no: ""
            }
        }

    }
</script>

<style lang="scss">
    @import './../../../sass/variables';
    @import "./../../../sass/base/_setting.scss";
    @import "./../../../sass/base/_default.scss";
    @import "./../../../sass/base/_base.scss";
    @import './assets/css/news.scss';
</style>
